var map = {
	"./background.png": 50,
	"./bird_brains.png": 51,
	"./burger_logger.png": 52,
	"./ctc.png": 53,
	"./digital_coffee.png": 54,
	"./employee_directory.png": 55,
	"./employee_management_tool.png": 56,
	"./headshot.jpg": 19,
	"./logo.png": 57,
	"./react_portfolio.png": 58,
	"./roam.png": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;